var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.service.text)}}),(_vm.service['formactions'])?_c('ActionButtonGroup',{attrs:{"save-button":false,"selected":_vm.selectFormaction,"service":_vm.service,"stacked":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }